import {useQuery} from '@tanstack/react-query';
import {AxiosResponse} from 'axios';
import {apiGet} from '../../../axiosConfig';
import {IProduct} from '../../../dto/Company.dto';
import {IMusicGenre} from '../../../dto/MusicGenre.dto';

// Get Product Gener List,Edit  Configurations
export type IProductListSearchQueryParams = {
  per_page?: number;
  page?: number;
  search?: string;
  sort_order?: string;
  sort_field?: string;
};

export const queryKeyProductRequestList = () => {
  return `/v1/product`;
};
export const useRqProductsList = (
  params: IProductListSearchQueryParams,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: [queryKeyProductRequestList(), params],
    queryFn: () => GetProductListApi(params),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: enabled,
    staleTime: 3600000, // 1 hour
  });
};

const GetProductListApi = (params: IProductListSearchQueryParams) => {
  return apiGet(queryKeyProductRequestList(), {params: params}).then(
    (response: AxiosResponse<IProduct[]>) => {
      return response.data;
    },
  );
};

export type iProductSecondaryLevelResp = {
  id: number;
  cmc_product: string;
  primary: string;
  secondary: string;
  level: string;
};

export type IProductLevelResponse = {
  cmc_product: string[];
  primary: string[];
  secondary: string[];
  level: string[];
  dma: string[];
  products: iProductSecondaryLevelResp[];
};
export const queryKeyProductWithLevelList = () => {
  return `/v1/product/list-with-level`;
};

export const useRqProductsLevelsList = (enabled: boolean) => {
  return useQuery({
    queryKey: [queryKeyProductWithLevelList()],
    queryFn: () => GetProductLevelsListApi(),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: enabled,
    staleTime: 3600000, // 1 hour
  });
};
const GetProductLevelsListApi = () => {
  return apiGet(queryKeyProductWithLevelList(), {}).then(
    (response: AxiosResponse<IProductLevelResponse>) => {
      return response.data;
    },
  );
};
export const queryKeyProductWithPrimaryList = () => {
  return `/v1/product/primary-product-type`;
};

const GetProductPrimaryListApi = (cmc_product: string) => {
  return apiGet(queryKeyProductWithPrimaryList(), {
    params: {cmc_product},
  }).then((response: AxiosResponse<string[]>) => {
    return response.data;
  });
};
export const useRqProductsPrimaryList = (
  enabled: boolean,
  cmc_product: string,
) => {
  return useQuery({
    queryKey: [queryKeyProductWithPrimaryList(), cmc_product],
    queryFn: () => GetProductPrimaryListApi(cmc_product),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: enabled,
    staleTime: 3600000, // 1 hour
  });
};

// Get Product Genre List
export type IProductGenereList = {
  hide_genres: IMusicGenre[];
  show_genres: IMusicGenre[];
};

// Get Product List Configuration

export type ITNNProductFilterLevel = {
  dma: string[];
  gt_primary: string[];
  nr_primary: string[];
  gt_secondary: string[];
  nr_secondary: string[];
};

export const queryKeyTNNProductFilterList = () => {
  return `/v1/product/tnn-product-filter`;
};

const GetTNNProductFilterListApi = () => {
  return apiGet(queryKeyTNNProductFilterList(), {}).then(
    (response: AxiosResponse<ITNNProductFilterLevel>) => {
      return response.data;
    },
  );
};

export const useRqTNNProductFiltersList = (enabled: boolean) => {
  return useQuery({
    queryKey: [queryKeyTNNProductFilterList()],
    queryFn: () => GetTNNProductFilterListApi(),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: enabled,
    staleTime: 3600000, // 1 hour
  });
};

export const getCmcProductsApi = `/v1/product/cmc-products`;

export const getCmcProducts = () => {
  return apiGet(getCmcProductsApi, {}).then(
    (response: AxiosResponse<{id: number; cmc_product: string}[]>) => {
      return response.data;
    },
  );
};

export const useRqCmcProductsList = (enabled: boolean = false) => {
  return useQuery({
    queryKey: [getCmcProductsApi],
    queryFn: () => getCmcProducts(),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: enabled,
    staleTime: 3600000 * 12, // 12 hours
  });
};
